import React from 'react';
import { RefreshCw, ExternalLink } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface PreviewPanelProps {
  previewUrl: string | null;
}

export default function PreviewPanel({ previewUrl }: PreviewPanelProps) {
  const [key, setKey] = React.useState(0);

  return (
    <div className="h-full flex flex-col">
      <div className="px-3 py-1.5 text-xs font-semibold uppercase text-muted-foreground border-b flex items-center justify-between">
        <span>Preview</span>
        {previewUrl && (
          <div className="flex items-center gap-1">
            <Button
              variant="ghost"
              size="icon"
              className="h-5 w-5"
              onClick={() => setKey((k) => k + 1)}
              title="Refresh"
            >
              <RefreshCw className="h-3 w-3" />
            </Button>
            <Button
              variant="ghost"
              size="icon"
              className="h-5 w-5"
              onClick={() => window.open(previewUrl, '_blank')}
              title="Open in new tab"
            >
              <ExternalLink className="h-3 w-3" />
            </Button>
          </div>
        )}
      </div>
      <div className="flex-1 bg-white">
        {previewUrl ? (
          <iframe
            key={key}
            src={previewUrl}
            className="w-full h-full border-0"
            title="Preview"
            sandbox="allow-scripts allow-forms allow-popups"
          />
        ) : (
          <div className="flex items-center justify-center h-full text-muted-foreground text-sm">
            No preview available. Click "Run" to start the dev server.
          </div>
        )}
      </div>
    </div>
  );
}
